import React, { Component } from "react";
import DeleteBtn from "../components/DeleteBtn";
import EditBtn from "../components/EditBtn";
import DisplayBtn from "../components/DisplayBtn/DisplayBtn";
import Jumbotron from "../components/Jumbotron";
import API from "../utils/API";
import { Link } from "react-router-dom";
import { Col, Row, Container } from "../components/Grid";
import { List, ListItem, ScreenBtn, PrintBtn, EmailBtn, TwBtn } from "../components/List";
import { Input, Select, TextArea, FormBtn } from "../components/Form"
import Nav from "../components/Nav";

class Admin extends Component {
  state = {
    _id: '', //shindata id 
    shinbay: [],
    title: "",
    description: "",
    menuorder: "",
    display_btn: "",
    category: "MAIN MENU",
    categories: [
      { name: 'MAIN MENU' },
      { name: 'SAKE' },
      //{ name: 'WHITE WINE' },
      { name: 'WINE' },
      { name: 'BEER' },
      //{ name: 'COCKTAIL' },
    ]
    //     synopsis: ""
  };

  componentDidMount() {
    this.loadAdmin();
  }

  loadAdmin = () => {
    const displays = [];
    API.getAdmin()
      .then(res => (
          this.setState({ shinbay: res.data, title: "", description: "", menuorder: "" }),
          res.data.map((item, index) => 
            displays[index] = item.display_on,
          ),
          this.setState({ display_btn: displays })
        )
      )
      .catch(err => console.log(err));
  };

  deleteShindata = id => {
    API.deleteShindata(id)
      .then(res => this.loadAdmin())
      .catch(err => console.log(err));
  };

  showEditShindata = (id, title, description, category, menuorder) => {
    this.setState({ _id: id, title: title, description: description, category: category, menuorder: menuorder });
  };

  handleInputChange = event => {
    const { name, value } = event.target;
    this.setState({
      [name]: value
    });
  };

  toggleDisplayBtn = (index, id) => {
    let cr_display = [];
    cr_display = [...this.state.display_btn];

    if( cr_display[index] === 'Off' ) {
      cr_display[index] = 'On';
      this.setState({ display_btn: cr_display });
    } else {
      cr_display[index] = 'Off';
      this.setState({ display_btn: cr_display });
    }

    let shindataData = {
      _id: id,
     display_on: cr_display[index],
    }

    API.editShindata(shindataData)
      .catch(err => console.log(err));
      this.setState({_id: ''})

  }

  handleFormSubmit = event => {
    event.preventDefault();
    const { title, description, _id, category, menuorder } = this.state;
    if (title && description && _id && menuorder) {
      let shindataData = {
        _id,
        title,
        menuorder,
        description,
        category,
      }
      API.editShindata(shindataData)
        .then(res => this.loadAdmin())
        .catch(err => console.log(err));
        this.setState({_id: ''})
    } else {
      API.saveShindata({
        title: this.state.title,
        description: this.state.description,
        category: this.state.category,
        menuorder: this.state.menuorder
        //         synopsis: this.state.synopsis
      })
        .then(res => this.loadAdmin())
        .catch(err => console.log(err));
    }
  };

  render() {
    return (

      <Container fluid>
        <Nav> </Nav>
        <br />
        <Row>
          <Col size="md-6">
            <Jumbotron>
              <h1>Add Menu</h1>
            </Jumbotron>
            <form>
              <Select 
                list={this.state.categories} 
                changed={this.handleInputChange}
                name="category" />

              <Input
                value={this.state.title}
                onChange={this.handleInputChange}
                name="title"
                placeholder="Name (required)"
              />

              <Input
                type="number"
                value={this.state.menuorder}
                onChange={this.handleInputChange}
                name="menuorder"
                min="0"
                placeholder="Menu Order (required)"
              />

              <TextArea
                value={this.state.description}
                onChange={this.handleInputChange}
                name="description"
                placeholder="Description (required)"
              />

              <FormBtn
                disabled={!(this.state.description && this.state.title)}
                onClick={this.handleFormSubmit}
              >
                Submit Menu
              </FormBtn>
            </form>
            <br /><br />
            <Jumbotron>
              <h1>Menu List</h1>
            </Jumbotron>

            {this.state.shinbay.length ? (
              <List>
                {this.state.shinbay.map((shindata, index) => (
                  ( this.state.category === shindata.category ) ?
                    <ListItem key={shindata._id}>
                      {/* <Link to={"/shinbay/" + shindata._id}> */}
                      <strong>
                        {shindata.title}
                      </strong>
                      <p>
                        {shindata.description}
                      </p>
                      <p>
                        Menu Order: {shindata.menuorder}
                      </p>
                      {/* </Link> */}
                      <DeleteBtn onClick={() => this.deleteShindata(shindata._id)} />
                      <EditBtn onClick={() => this.showEditShindata(shindata._id, shindata.title, shindata.description, shindata.category, shindata.menuorder)} />

                      <DisplayBtn condition={ this.state.display_btn[index] } clicked={() => this.toggleDisplayBtn(index, shindata._id)} />
                    </ListItem>
                  : null
                ))}
              </List>
            ) : (
                <p>No Results to Display</p>
              )}
          </Col>
          <Col size="md-6 sm-12">
            <Jumbotron>
              <h1>Menu Preview</h1>
            </Jumbotron>
            {this.state.shinbay.length ? (
              <List>
                {this.state.shinbay.map((shindata, index) => (
                  ( this.state.category === shindata.category ) ?
                    ( this.state.display_btn[index] === 'On' ) ?
                      <ListItem key={shindata._id}>

                        <strong>
                          {shindata.title}
                        </strong>
                        <p>
                          {shindata.description}
                        </p>

                      </ListItem>
                    : null
                  : null
                ))}
              </List>

            ) : (
                <p>No Results to Display</p>

              )}


            <Link to={"/view"}>
              <ScreenBtn>
                Screen View
		</ScreenBtn>
            </Link>

            <Link to={{
              pathname: "/print",
              category: this.state.category 
            }}>
              <PrintBtn>
                Print
		</PrintBtn>
            </Link>

            <EmailBtn>
              Send Email
	</EmailBtn>

            <TwBtn>
              Facebook
	</TwBtn >
          </Col>

        </Row>
      </Container>
    );
  }
}

export default Admin;
